import { Card } from 'antd';
import React, {  } from 'react';


export const CardBox = ({title, extra, children}:any) => {
    return <Card title ={title} extra={extra}>
            {children}
    </Card>
}
export default CardBox;